import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { Constants, PROJECT, RemoveAndPayStockOutModalTrackingEvent, TrackingEventName } from "./tracking";

interface TrackRemoveAndPayStockOutModalFunctionArgs {
  readonly variantId: string;
  readonly products: Product[];
}

interface TrackRemoveAndPayStockOutModalFunction {
  (args: TrackRemoveAndPayStockOutModalFunctionArgs): void;
}

interface UseTrackRemoveAndPayStockOutModalFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackRemoveAndPayStockOutModalFunction {
  (agrs: UseTrackRemoveAndPayStockOutModalFunctionArgs): TrackRemoveAndPayStockOutModalFunction;
}

const useTrackRemoveAndPayStockOutModal: UseTrackRemoveAndPayStockOutModalFunction = ({
  country,
  segment,
  tradename,
  userId,
}) => {
  const emitUserEvent = useEmitUserEvent<RemoveAndPayStockOutModalTrackingEvent>();

  const trackRemoveAndPayStockOutModal: TrackRemoveAndPayStockOutModalFunction = useCallback(
    ({ variantId, products }) => {
      emitUserEvent({
        event: TrackingEventName.REMOVE_AND_PAY_STOCK_OUT_MODAL,
        eventCategory: TrackingEventCategory.LOOK_IN,
        store: country,
        section: PROJECT,
        segment,
        tradename,
        userId,
        userUuid: userId,
        variant_id: variantId,
        items: products.map((product) => ({
          item_id: product._variantId,
          item_list_name: Constants.COMPLETE_YOUR_LOOK_LIST,
          item_price: product.price.amount || 0,
          item_brand: product.brand || Constants.NOT_SET,
          item_category: Constants.NOT_SET,
          item_list: Constants.COMPLETE_YOUR_LOOK_LIST,
          item_index: Constants.INDEX,
          item_look_id: Constants.NOT_SET,
          item_quantity: Constants.QUANTITY,
        })),
      });
    },
    [country, emitUserEvent, segment, tradename, userId],
  );

  return trackRemoveAndPayStockOutModal;
};

export { useTrackRemoveAndPayStockOutModal };
